.page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.container {
  position: relative;
  display: flex;
  padding-top: 1.6rem;
  flex-direction: row;
  gap: 2.4rem;
  margin-inline-start: 1.6rem;
  min-height: 0;
  height: 100%;
}

.scroll-container {
  padding-bottom: 1.6rem;
  padding-right: 1.2rem;
  min-height: 0;
  overflow-y: auto;
  max-height: 100%;
  flex: 1 0 32rem;
}
